import { Component, Input, OnInit } from "@angular/core";
import {Order} from "../../../../objects/orders/order";
import {BaseCalculatorTab} from "./baseCalculatorTab";
import {OrderItem} from "../../../../objects/orders/orderItem";
import {CalculatorHelper} from "../../../../common/helpers/calculatorHelper";
import {Router} from "@angular/router";
import { TaxService } from "../../../../services/calculator/tax.service";
import { OrderOptions } from "../../../../objects/orders/orderOptions";
/**
 * Created by alex.y on 8/11/2017.
 */

@Component({
    selector: "cad-calc-tab",
    templateUrl: "./canadianCalculator.component.html",
    moduleId: module.id.toString()
})
export class CanadianCalculatorComponent extends BaseCalculatorTab implements OnInit{

    @Input()
    public orderItem: OrderItem;

    @Input()
    public currency: string;

    @Input()
    public order: Order;

    @Input()
    public clonedOrder: Order;

    @Input()
    public clonedOrderItem: OrderItem;

    public string = String;
    public calculatorHelper = CalculatorHelper;

    public showHst: boolean = false;
    public showQst: boolean = false;
    public isVehicle: boolean = false;

    constructor(public router: Router,
                public taxService: TaxService) {
        super();
    }

    public ngOnInit(): void{
        if(this.order && this.order.Locations.length > 0)
        this.setHQst();
        if(this.order && this.order.Flag)
            this.isVehicle = this.order.Flag.hasFlag(OrderOptions.IsVehicle);
    }

    private setHQst() : void{
        const isHQst = CalculatorHelper.isHQst(this.order);

        if(isHQst == null)
            return;

        if(isHQst == true)
            this.showHst = true;

        if(isHQst == false)
            this.showQst = true;
    }

    public isMoreOrEqThanTwentyFive(): boolean{
        return CalculatorHelper.isMoreOrEqThanTwentyFive(this.order, this.orderItem);
    }

    public isFreeCustomDuty(): boolean {
        // if(this.orderItem.Product && (this.orderItem.Product.HsCode == "9999.99.99.99" || this.orderItem.Product.HsCode == "9999.99.99.98"))
        //     return false;

        return this.isMoreOrEqThanTwentyFive()
    }

    public readonly OrderOptions = OrderOptions;
}



// WEBPACK FOOTER //
// ./app/components/calculator/tabs/calculatorResults/canadianCalculator.component.ts